module.exports = __webpack_public_path__ + "static/img/gather-member.25652fea.png";